// import { Link } from "react-router-dom"
import "../css/Navigation.css"

export const Navigation = () => {
    return <nav>
        <ul className="nav-bar">
            <li className="nav-list"><a href="/contact">Contact</a></li>
            <li className="nav-list"><a href="/projects">Portfolio</a></li>
            <li className="nav-list"><a href="/about">About Me</a></li>
            <li className="nav-list"><a href="/">Home</a></li>
        </ul>
    </nav>
}